import React, { useContext } from "react";

import { faPlusCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ReactComponent as Illustration } from "~/legacy-assets/images/illustrations/empty-state.svg";
import { OKRsContext } from "~/okrs/ObjectiveList";
import { Button } from "~/ui";

import styles from "./BigCreateObjectiveButton.module.css";

interface BigCreateObjectiveButtonProps {
	includeEmptyState?: boolean;
}

export default function BigCreateObjectiveButton({ includeEmptyState }: BigCreateObjectiveButtonProps) {
	const { openCreateObjectiveModal } = useContext(OKRsContext);

	return (
		<div className={styles.wrapper}>
			<Button size="wide" className={styles.bigCreateButton} onClick={openCreateObjectiveModal}>
				<div className={styles.bigCreateButtonText}>
					<FontAwesomeIcon icon={faPlusCircle} />
					<span>Create new objective</span>
				</div>
			</Button>
			{includeEmptyState && (
				<>
					<Illustration className={styles.illustration} />
					<div className={styles.label}>
						<p>All objectives that are visible to you will be displayed here.</p>
					</div>
				</>
			)}
		</div>
	);
}
